import React from "react";
import { Spinner } from "./spinner";

export function PageLoader({ label }: { label?: string }) {
  return (
    <div className="h-screen w-screen flex flex-col justify-center items-center gap-3">
      <Spinner size="lg" />
      {label && (
        <p className="text-sm text-foreground-muted animate-pulse">{label}</p>
      )}
    </div>
  );
}
